import { render, staticRenderFns } from "./productTrace.vue?vue&type=template&id=8a7754de&scoped=true"
import script from "./productTrace.vue?vue&type=script&lang=js"
export * from "./productTrace.vue?vue&type=script&lang=js"
import style0 from "./productTrace.vue?vue&type=style&index=0&id=8a7754de&prod&scoped=true&lang=css"
import style1 from "./productTrace.vue?vue&type=style&index=1&id=8a7754de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7754de",
  null
  
)

export default component.exports